import { render, staticRenderFns } from "./ContactEditButton.vue?vue&type=template&id=f0c3100c"
import script from "./ContactEditButton.vue?vue&type=script&lang=js"
export * from "./ContactEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports